import React, { Component } from "react";
import { Menu } from "antd";

const SubMenu = Menu.SubMenu;

class SideNav extends Component {
    render () {
        const { selectKey } = this.props;
        return (
            <aside className="sidebar">
                <Menu
                    openKeys={['sub1']}
                    selectedKeys={[selectKey]}
                    mode="inline"
                >
                    <SubMenu key="sub1" title={<span><i className="icon iconfont">&#xe664;</i><span>文件管理</span></span>}>
                        <Menu.Item key="projectFile">
                            <a href="#/fileManagement/projectFile">项目文档</a>
                        </Menu.Item>
                    </SubMenu>
                </Menu>
            </aside>
        );
    }
}

export default SideNav;



// WEBPACK FOOTER //
// ./src/components/fileManagement/SideNav.js